import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconServices({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 15.67 15.6716" fill="none">
      <Path
        fill={fill}
        d="M6.88287 4.81118C6.8828 5.34841 6.76258 5.95316 6.27281 6.38732C5.81046 6.79698 5.20247 6.88468 4.65626 6.88191L2.22757 6.88287C1.68348 6.88287 1.07412 6.79476 0.611019 6.38443C0.12033 5.94964 0 5.34371 0 4.80444V2.07843C3.87413e-05 1.54038 0.121569 0.936813 0.610057 0.502287C1.07213 0.0913861 1.6804 0 2.22757 0H4.65626C5.20342 3.9048e-05 5.81178 0.0913252 6.27377 0.502287C6.76226 0.936813 6.88283 1.54038 6.88287 2.07843V4.81118Z"
      />
      <Path
        fill={fill}
        d="M15.67 4.81118C15.6699 5.34841 15.5497 5.95316 15.0599 6.38732C14.5976 6.79698 13.9896 6.88468 13.4434 6.88191L11.0147 6.88287C10.4706 6.88287 9.86125 6.79476 9.39815 6.38443C8.90746 5.94964 8.78713 5.34371 8.78713 4.80444V2.07843C8.78717 1.54038 8.9087 0.936813 9.39719 0.502287C9.85926 0.0913861 10.4675 0 11.0147 0H13.4434C13.9906 3.9048e-05 14.5989 0.0913252 15.0609 0.502287C15.5494 0.936813 15.67 1.54038 15.67 2.07843V4.81118Z"
      />
      <Path
        fill={fill}
        d="M6.88287 13.5999C6.8828 14.1371 6.76258 14.7418 6.27281 15.176C5.81046 15.5857 5.20247 15.6734 4.65626 15.6706L2.22757 15.6716C1.68348 15.6716 1.07412 15.5834 0.611019 15.1731C0.12033 14.7383 0 14.1324 0 13.5931V10.8671C3.87413e-05 10.3291 0.121569 9.7255 0.610057 9.29097C1.07213 8.88007 1.6804 8.78868 2.22757 8.78868H4.65626C5.20342 8.78872 5.81178 8.88001 6.27377 9.29097C6.76226 9.7255 6.88283 10.3291 6.88287 10.8671V13.5999Z"
      />
      <Path
        fill={fill}
        d="M15.67 13.5999C15.6699 14.1371 15.5497 14.7418 15.0599 15.176C14.5976 15.5857 13.9896 15.6734 13.4434 15.6706L11.0147 15.6716C10.4706 15.6716 9.86125 15.5834 9.39815 15.1731C8.90746 14.7383 8.78713 14.1324 8.78713 13.5931V10.8671C8.78717 10.3291 8.9087 9.7255 9.39719 9.29097C9.85926 8.88007 10.4675 8.78868 11.0147 8.78868H13.4434C13.9906 8.78872 14.5989 8.88001 15.0609 9.29097C15.5494 9.7255 15.67 10.3291 15.67 10.8671V13.5999Z"
      />
    </Svg>
  )
}
